import { createReducer, on } from '@ngrx/store';
import { initialErrorState } from '../states/error.state';
import { globalError, resetError } from '../actions/error.actions';
import { HttpErrorResponse } from '@angular/common/http';

export const errorReducer = createReducer(
  initialErrorState,
  on(globalError, (state, { error }) => {
    // Ignorer les erreurs 401/403 car elles sont toujours gérées par l'intercepteur HTTP
    // (redirection pour 401, modal pour 403)
    if (error instanceof HttpErrorResponse || (error && typeof error === 'object')) {
      const status = error.status || error.code;

      // Si c'est une erreur 401 ou 403, ne pas la mettre dans le store
      // car l'intercepteur HTTP les gère déjà (redirection ou modal)
      if (status === 401 || status === 403 || status === '401' || status === '403') {
        console.log(
          "%c[error.reducer] Erreur 401/403 ignorée - Déjà gérée par l'intercepteur HTTP",
          'color: green;',
        );
        return state; // Ne pas modifier l'état
      }
    }

    return { ...state, error };
  }),
  on(resetError, () => initialErrorState),
);
